export default __webpack_public_path__ + "static/media/pdf_img.b56a69df.jpg";